// encryptionUtils.js
import CryptoJS from 'crypto-js';

// Read the encryption key from the environment variable
const encryptionKeyHex = process.env.REACT_APP_ENCRYPTION_KEY;

// Convert hex string to a WordArray key
const key = CryptoJS.enc.Hex.parse(encryptionKeyHex);

/**
 * Decrypt base64-encoded (IV + ciphertext) from server's AES-256-CBC.
 */
export function decryptData(encryptedData) {
  // 1) Decode from base64 into a CryptoJS WordArray
  const combinedWordArray = CryptoJS.enc.Base64.parse(encryptedData);

  // 2) The IV is the first 16 bytes (128 bits) => which is 16/4=4 words
  const iv = CryptoJS.lib.WordArray.create(
    combinedWordArray.words.slice(0, 4) // 4 words = 16 bytes
  );

  // 3) Ciphertext is the remainder
  const ciphertext = CryptoJS.lib.WordArray.create(
    combinedWordArray.words.slice(4)
  );

  // 4) Decrypt using AES-256-CBC with PKCS7 padding
  const decrypted = CryptoJS.AES.decrypt(
    { ciphertext },
    key,
    {
      iv: iv,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7,
    }
  );

  // 5) Convert the decrypted bytes to UTF-8 text, then parse JSON
  const decryptedText = decrypted.toString(CryptoJS.enc.Utf8);
  return JSON.parse(decryptedText);
}
